export default __webpack_public_path__ + "static/media/icon_trigger_active.8868a9b4.svg";